// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coze-brand-SkC442{height:32px;display:flex}.coze-brand-SkC442>svg{width:100%;height:100%}.brand-button-A1dT6C{cursor:pointer;color:#1d1c23;white-space:nowrap;background:0 0;border:0;align-items:center;gap:8px;padding:0;font-family:inherit;font-size:20px;font-weight:600;line-height:32px}.brand-button-A1dT6C .brand-icon-pYXXUD{-o-object-fit:contain;object-fit:contain;flex-shrink:0;width:32px;height:32px}.brand-white-wQoZ9j{color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coze-brand": `coze-brand-SkC442`,
	"cozeBrand": `coze-brand-SkC442`,
	"brand-button": `brand-button-A1dT6C`,
	"brandButton": `brand-button-A1dT6C`,
	"brand-icon": `brand-icon-pYXXUD`,
	"brandIcon": `brand-icon-pYXXUD`,
	"brand-white": `brand-white-wQoZ9j`,
	"brandWhite": `brand-white-wQoZ9j`
};
export default ___CSS_LOADER_EXPORT___;
